<template>
  <div class="wlx-user-manager-wrapper">
    <header class="site-manager-head-con" style="padding-top:20px;">
      <el-form :inline="true" size="small">
        <el-form-item>
          <el-input v-model="userName" placeholder="请输入用户账号" clearable></el-input>
        </el-form-item>
        <el-form-item>
          <el-input v-model="displayName" placeholder="请输入用户姓名" clearable></el-input>
        </el-form-item>
        <el-form-item>
          <el-select v-model="schoolId" clearable placeholder="请选择学校" filterable>
            <el-option
              v-for="item in schoolList"
              :key="item.id"
              :label="item.name"
              :value="item.id">
            </el-option>
          </el-select>
          <!-- <el-input v-model="displayName" placeholder="请输入用户姓名" clearable></el-input> -->
        </el-form-item>
        <el-form-item>
          <el-button type="primary" icon="el-icon-search" @click="getAllUserList()">搜索</el-button>
        </el-form-item>
      </el-form>
    </header>

    <el-table :data="siteList">
        <el-table-column label="序号" type="index" width="50"></el-table-column>
          <el-table-column prop="userName" label="账号"></el-table-column>
          <el-table-column prop="displayName" label="姓名"></el-table-column>
          <!-- <el-table-column prop="sex" label="性别">
            <template slot-scope="scope">
             <span v-if="scope.row.sex == 0">男</span>
             <span v-if="scope.row.sex == 1">女</span>
             </template>
          </el-table-column> -->
          <el-table-column prop="phone" label="手机号"></el-table-column>
          <el-table-column prop="schoolName" label="所属学校"></el-table-column>
          <!-- <el-table-column prop="ancestor" label="民族"></el-table-column> -->
          <el-table-column prop="dateCreated" label="创建时间"></el-table-column>
          <el-table-column label="操作">
            <template slot-scope="scope">
                 <el-tooltip class="item" effect="dark" content="修改信息" placement="top">
                    <el-button icon="el-icon-edit" size="mini" type="primary" @click="openEditInfo(scope.row)"></el-button>
                </el-tooltip>
                <el-tooltip class="item" effect="dark" content="修改密码" placement="top">
                    <el-button icon="el-icon-refresh" size="mini" type="primary" @click="goLook(scope.row.id)"></el-button>
                </el-tooltip>
            </template>
          </el-table-column>
    </el-table>

    <div class="u-page-con">
      <el-pagination
        background
        @size-change="handleSizeChange"
        @current-change="onPageChangeHandler"
        :current-page="page"
        :page-sizes="[10, 20, 50, 100,200,500,1000]"
        :page-size="pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="totalCount"
        v-show="totalCount>0"
        style="text-align: center;"
      ></el-pagination>
    </div>

    <el-dialog
        title="修改密码"
        :visible.sync="dialogVisible"
        append-to-body
        width="30%">
        <div>
            <el-input v-model="newPassword" placeholder="请输入新密码" clearable></el-input>
        </div>
        <span slot="footer" class="dialog-footer">
            <el-button @click="dialogVisible = false">取 消</el-button>
            <el-button type="primary" @click="newPasswords()">确 定</el-button>
        </span>
    </el-dialog>


    <el-dialog
        title="修改信息"
        :visible.sync="editDialogVisible"
        append-to-body
        width="30%">
        <div>
          <el-form label-width="80px">
            <el-form-item label="姓名">
              <el-input v-model="editInfoForm.displayName"></el-input>
            </el-form-item>
            <el-form-item label="手机号">
              <el-input v-model="editInfoForm.phone"></el-input>
            </el-form-item>
            <el-form-item label="学校">
              <el-select v-model="editInfoForm.schoolId" clearable placeholder="请选择学校" filterable>
                <el-option
                  v-for="item in schoolList"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id">
                </el-option>
              </el-select>
            </el-form-item>
          </el-form>
        </div>
        <span slot="footer" class="dialog-footer">
            <el-button @click="editDialogVisible = false">取 消</el-button>
            <el-button type="primary" @click="editUserInfo()">确 定</el-button>
        </span>
    </el-dialog>
  </div>
</template>

<script>
export default {
  data() {
    return {
      page: 1,
      pageSize: 10,
      totalCount: 0,
      siteList:[],
      dialogVisible: false,
      userName:'',
      displayName:'',
      newPassword:'',
      id :"",
      schoolList:[],
      schoolId:"",
      // 修改信息
      editInfoForm:{
        id:"",
        displayName:"",
        phone:"",
        schoolId:""
      },
      editDialogVisible:false,
    };
  },
  components: {},
 
  created() {
    this.getAllUserList();
    this.getSchoolList();

  },
  methods: {
    openEditInfo(row){
      this.editInfoForm.id = row.id;
      this.editInfoForm.displayName = row.displayName;
      this.editInfoForm.phone = row.phone;
      this.editInfoForm.schoolId = row.schoolId;
      this.editDialogVisible = true;
    },
    editUserInfo(){
      var that = this;
      this.$http
        .post("/api/XOrg/AssessmentApply/editUserInfo", {
          id:that.editInfoForm.id,
          displayName : that.editInfoForm.displayName,
          phone: that.editInfoForm.phone,
          schoolId: that.editInfoForm.schoolId
        })
        .then(rst => {
          if(rst.code>0){
            this.$message.success(rst.msg);
            this.editDialogVisible = false;
            that.getAllUserList();
          }else{
            this.$message.warning(rst.msg);
          }
        });
    },
    goLook(id) {
      this.id = id;
      this.dialogVisible = true;
    },
    handleSizeChange(val) {
      this.pageSize = val;
      this.getAllUserList();
    },
    onPageChangeHandler(val) {
      this.page = val;
      this.getAllUserList();
    },
    newPasswords(){
      var that = this;
      this.$http
        .post("/api/XOrg/AssessmentApply/updatePassWord", {
          id:that.id,
          newPassword : that.newPassword,
          PageSize: that.pageSize,
          page: that.page
        })
        .then(rst => {
          if(rst.code>0){
            this.$message.success(rst.msg);
            this.dialogVisible = false;
          }else{
            this.$message.warning(rst.msg);
          }
        });
    },
    getAllUserList() {
      var that = this;
      this.$http
        .post("/api/XOrg/AssessmentApply/getAllUserList", {
          userName : that.userName,
          displayName : that.displayName,
          schoolId:that.schoolId,
          PageSize: that.pageSize,
          page: that.page
        })
        .then(rst => {
          that.siteList = rst.list;
          that.page = rst.pagination.pageIndex;
          that.pageSize = rst.pagination.pageSize;
          that.totalCount = rst.pagination.totalCount;
        });
    },
    //获取学校列表
    getSchoolList(){
      var that = this;
      this.$http
        .post("/api/common/login/getSchoolList", {})
        .then(rst => {
          if(rst.code > 0){
            that.schoolList = rst.list;
          }
        });
    }
  }
};
</script>
<style lang="scss">
.wlx-user-manager-wrapper{
    padding-left: 30px;
    .site-manager-head-con{
        text-align: right;
    }
}
</style>
